import React from "react";
import Header from "../../components/Header";
import { StyledMainContainer } from "../../styles/global";

const PageNotFound = () => {
  return (
    <>
      <Header title="WhatQR" />
      <StyledMainContainer
        style={{
          padding: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "100vh",
          overflowY: "hidden",
        }}
      >
        <img className="pnf-img" src="/assets/imgs/404.png" alt="404" />
        <h1 className="pnf-text">404 Page not found</h1>
      </StyledMainContainer>
    </>
  );
};

export default PageNotFound;
